import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// import Table from "../../../../core/common/dataTable/index";
import ApplicationTable from "./ApplicationTable";
import { getApplications } from "../auth/services/privateapicalling";
import { useSelector } from "react-redux";

const PendingToClerk = () => {
    const [selectedAction, setSelectedAction] = useState("All");
    const userDetails = useSelector((state:any)=>state.auth.userDetails)
    const roleIdentifier = useSelector((state: any) => state.auth.userDetails?.Role?.Role_Identifier);
     const language = useSelector((state:any)=>state.auth.language);
   
      
      const statusOptions = [
        // {value: "all" , label:"All"},
          { value: "all_pending", label: "All Application" ,  role:["JC" , "COM" , "Dr" , "DY", "DT","SA"] },
        { value: "pendingAtClerk", label: "Pending with Dist. Clerk" ,  role:["JC" , "COM" , "Dr" ,  "HJC" , "HOS" ,"SC", "DY", "DT","SA"] },
        { value: "pendingAtCo", label: "Pending With Dist. Cooperative Officer Marketing" , role:["COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtDr", label: "Pending with Dist. Registrar", role:[ "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtClerkResubmission", label: "Pending Resubmission with Dist. Clerk" ,  role:["JC" , "COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]},
        { value: "pendingAtCoResubmission", label: "Pending Resubmission with Dist. Cooperative Officer Marketing" ,  role:["COM" , "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"] },
        { value: "pendingAtDrResubmission", label: "Pending Resubmission with Dist. Registrar" , role:[ "Dr" ,  "HJC" ,"SC", "HOS" , "DY", "DT","SA"]  },
   
      ];

      const rolePriorityMap: Record<string, string> = {
        JC: "all_pending",
        COM: "all_pending",
        Dr: "all_pending",
      };
     
      const filteredOptions = statusOptions.filter(option => option.role.includes(roleIdentifier));
     
      // Get the first option based on the roleIdentifier
      const firstOptionValue = rolePriorityMap[roleIdentifier] || filteredOptions[0]?.value;
      
      // Reorder the options to place the matched option first
      const reorderedStatusOptions = [
        filteredOptions.find(option => option.value === firstOptionValue),
        ...filteredOptions.filter(option => option.value !== firstOptionValue)
      ].filter(Boolean); // Removes `null` values in case of undefined
      



    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{language.application_list}</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
                            <ApplicationTable status={reorderedStatusOptions} />
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
        </>
    );
};

export default PendingToClerk;
